export class PostFiltroRelatorio {
    idPlano: number;
    regimeTributario: string;
    dataInicio: Date;
    dataFim: Date;
}